import { Card, Heading } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import TileImage from '../../../../shared/TileImage/TileImage';

export interface ServicesCategoryCardInterface {
  name: string;
  url: string;
  imageUrl: string;
}

interface ServicesCategoryCardProps extends ServicesCategoryCardInterface {
  onSelectCategory: (insuranceOffer: ServicesCategoryCardInterface) => void;
}

const ServicesCategoryCard: FC<ServicesCategoryCardProps> = ({
  name,
  imageUrl,
  url,
  onSelectCategory,
}) => {
  const handleClick = () => {
    onSelectCategory({ name, url, imageUrl });
  };

  return (
    <TileImage
      name={name}
      imageUrl={imageUrl}
      url={url}
      onClick={handleClick}
    />
  );
};

export default ServicesCategoryCard;
